// Av Control
export function searchAvControl(query) {
  return { path: `av_controls${query}` };
}

export function getAvControl(id) {
  return { path: `av_controls/${id}` };
}

export function createAvControl(name) {
  return {
    path: 'av_controls',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateAvControl(id, name) {
  return {
    path: `av_controls/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteAvControl(id) {
  return {
    path: `av_controls/${id}`,
    method: 'DELETE',
  };
}
